import React from "react";
import { Provider } from "components/account-register-history/AccountRegisterHistoryContext";
import { AccountRegisterHistoryList } from "components/account-register-history/AccountRegisterHistoryList";

export const AccountRegisterHistories = () => {
    return (
        <Provider>
            <AccountRegisterHistoryList />
        </Provider>
    );
};
